// ContextMenu.tsx (S26) - the Local | Pro context menu. Reference lane #5 (EA Sports FC): confident
// tiles, a clear hierarchy, one step to the thing (not FC's everything-two-clicks-deep nav). Local is
// the shipping cash trainer and reads gold-active; Pro is the post-v1 pro-vs-pro immersion table, so
// it is HONESTLY locked as a "later phase" preview rather than a dead button that pretends to work.
export type ContextMode = 'local' | 'pro';

export interface ContextMenuProps {
  /** the active mode (Pro is not selectable in v1). */
  mode: ContextMode;
  /** enter Local training (the Observe/Diagnose/Solo spine). */
  onLocal: () => void;
  /** open the import-a-hand surface (a Local sub-feature). */
  onImport: () => void;
}

export function ContextMenu({ mode, onLocal, onImport }: ContextMenuProps) {
  return (
    <div className="ctxmenu">
      <button type="button" className={'tile' + (mode === 'local' ? ' active' : '')} onClick={onLocal}>
        <div className="tile-top">
          <span className="kick">Now training</span>
          <span className="badge">Active</span>
        </div>
        <div className="name">Local</div>
        <div className="sub">Read $1/$3 live players. Observe, Diagnose, Solo the read, price, and play.</div>
        <span className="go">{'→'}</span>
      </button>

      <div className="tile locked" aria-disabled="true">
        <div className="tile-top">
          <span className="kick">Immersion</span>
          <span className="badge">Later phase</span>
        </div>
        <div className="name">Pro</div>
        <div className="sub">Sit at a pro-vs-pro table and study the game at speed. Arriving after the cash v1 ships.</div>
        <span className="go">{'●'}</span>
      </div>

      <button type="button" className="ctx-import" onClick={onImport}>
        Import a hand to review
      </button>
    </div>
  );
}
